(function () {
  'use strict';

  function updateResponsiveCertificate() {
    const screenWidth = window.innerWidth;
    const headline = document.querySelector('.Pdp-Certificate-Card-Headline');
    const subtext = document.querySelector('.Pdp-Certificate-Card-Subtext');

    if (!headline || !subtext) return;

    if (screenWidth <= 767) {
      headline.classList.remove('text-headline-m-desktop');
      headline.classList.add('text-headline-m-mobile');
      subtext.classList.remove('text-body-l');
      subtext.classList.add('text-body-s');
    } else {
      headline.classList.remove('text-headline-m-mobile');
      headline.classList.add('text-headline-m-desktop');
      subtext.classList.remove('text-body-s');
      subtext.classList.add('text-body-l');
    }
  }

  updateResponsiveCertificate();
  window.addEventListener('resize', updateResponsiveCertificate);
})();
